import React, { createContext, useEffect, useState, useContext } from 'react';
import { saveWorkflowGraph } from '../services/workflows';
import { getAgents } from "../services/clients";
import { saveAgent } from "../services/agents";
import { AppContext } from './AppContext';

const AgentsContext = createContext();

const getDefaultWorkflow = () => {
  const defaultNodes = [
    {
      id: "1",
      position: { x: 50, y: (window.innerHeight / 2) - 150 },
      data: { label: "Input" },
      type: "inputNode",
      draggable: true,
    },
    {
      id: "2",
      position: { x: window.innerWidth - 1000, y: (window.innerHeight / 2) - 150 },
      data: { label: "Text Output" },
      type: "textOutputNode",
      draggable: true,
    },
  ];

  const defaultEdges = [
    {
      id: "e1-1",
      source: "1",
      target: "2",
      label: "default-output",
    }
  ];

  return {
    nodes: defaultNodes,
    edges: defaultEdges,
  }
};

export const AgentsProvider = ({ children }) => {
  const [agents, setAgents] = useState([]);
  const [workflows, setWorkflows] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [updatedAgent, setUpdatedAgent] = useState();
  const [selectedWorkflow, setSelectedWorkflow] = useState();
  const [selectedChatSession, setSelectedChatSession] = useState(null);
  const [updatedWorkflow, setUpdatedWorkflow] = useState();

  const { selectedClient } = useContext(AppContext);
  console.log("!!! SELECTED CLIENT IN data SETS CONTEXT: ", selectedClient);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        setAgents(
          await getAgents(selectedClient.public_id ?? selectedClient.id)
        );
        console.log(agents);
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM AGENTS: ", selectedClient);
    if (selectedClient) {
      fetchAgents();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  useEffect(() => {
    console.log("!!! UPDATED AGENT CHANGED: ", updatedAgent);
    // Get the data set items
    /*const fetchWorkflow = async () => {
      if (updatedAgent && updatedAgent.public_id) {
        const results = await getWorkflow(updatedAgent.public_id);
        if (results.success) {
          setSelectedWorkflow(results.items || []);
        }
      } else {
        setSelectedWorkflow([]);
      }
    }
 
    fetchWorkflow();*/
  }, [updatedAgent]);

  const addAgent = (dataSet) => {
    setAgents([...agents, dataSet]);
  };

  const removeAgent = (dataSetId) => {
    setAgents(agents.filter(dataSet => dataSet.id !== dataSetId));
  };

  const saveUpdatedAgent = async () => {
    console.log("!!! SAVE UPDATED data SET CALLED: ", updatedAgent);


    const results = await saveAgent(updatedAgent, selectedClient.id);
    if (results.success) {
      const agent = results.agent;
      setSelectedAgent(agent);
      setUpdatedAgent(agent);
      return agent.public_id;
    }
  }

  const saveUpdatedWorkflow = async () => {
    console.log("!!! SAVE UPDATED WORKFLOW CALLED: ", updatedWorkflow);

    //const newWorkflow = !updatedWorkflow.public_id;

    const results = await saveWorkflowGraph(updatedWorkflow, selectedClient.id);
    if (results.success) {
      const workflow = results.workflow;
      setSelectedWorkflow(workflow);
      setUpdatedWorkflow(workflow);
      return workflow.public_id;
    }
  }


  /*const shallowDiff = (obj1, obj2) => {
    const diff = {};

    if (obj1 == null) {
      for (const key in obj2) {
        diff[key] = {
          from: null,
          to: obj2[key]
        };
      }
      return diff;
    } else if (obj2 == null) {
      for (const key in obj1) {
        diff[key] = {
          from: obj1[key],
          to: null
        };
      }
      return diff;
    }


    const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

    for (const key of allKeys) {
      if (obj1[key] !== obj2[key]) {
        diff[key] = {
          from: obj1[key],
          to: obj2[key]
        };
      }
    }

    return diff;
  }*/

  const addWorkflow = (items) => {
    setSelectedWorkflow([...selectedWorkflow, ...items]);
  };

  const removeAgentItem = (itemId) => {
    setSelectedWorkflow(selectedWorkflow.filter((item) => {
      console.log("!!! COMPARING: ", item.public_id, item.id, " TO ", itemId);
      return item.public_id !== itemId && item.id !== itemId
    }));
  };

  const canSaveAgent = () => {
    if (!updatedAgent || !updatedAgent.name) return false;
    return true;


    // Remove image_data, local_open_date, local_recording_date, and local_start_date from the comparison since they are not part of the actual dataset object and are only used for handling date inputs
    /*
    const diff = shallowDiff(selectedAgent, updatedAgent);
    let changed = false;
    for (const key in diff) {
      if (diff[key].from !== diff[key].to) {
        console.log(`!!! KEY ${key} CHANGED: `, diff[key]);
        changed = true;
        break;
      }
    }
    return changed;
    */
  }

  const canSaveWorkflow = () => {
    if (!updatedWorkflow || !updatedWorkflow.name) return false;
    return true;


    // Remove image_data, local_open_date, local_recording_date, and local_start_date from the comparison since they are not part of the actual dataset object and are only used for handling date inputs
    /*
    const diff = shallowDiff(selectedAgent, updatedAgent);
    let changed = false;
    for (const key in diff) {
      if (diff[key].from !== diff[key].to) {
        console.log(`!!! KEY ${key} CHANGED: `, diff[key]);
        changed = true;
        break;
      }
    }
    return changed;*/
  }

  return (
    <AgentsContext.Provider value={{ agents, setAgents, selectedAgent, setSelectedAgent, addAgent, removeAgent, updatedAgent, setUpdatedAgent, canSaveAgent, saveUpdatedAgent, getDefaultWorkflow, selectedWorkflow, setSelectedWorkflow, addWorkflow, removeAgentItem, workflows, setWorkflows, updatedWorkflow, setUpdatedWorkflow, canSaveWorkflow, saveUpdatedWorkflow, selectedChatSession, setSelectedChatSession }}>
      {children}
    </AgentsContext.Provider>
  );
}

export const useAgents = () => {
  return useContext(AgentsContext);
}

export default AgentsContext;
